function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 296,
  cy: 304,
  r: 200,
  stroke: "black",
  strokeWidth: 400,
  strokeDasharray: "24 24"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1_488)"
}, /*#__PURE__*/React.createElement("circle", {
  opacity: 0.3,
  cx: 295.5,
  cy: 303.5,
  r: 377.5,
  fill: "url(#paint0_radial_1_488)"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_1_488",
  x: -92,
  y: -84,
  width: 775,
  height: 775,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  result: "effect1_foregroundBlur_1_488"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_1_488",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(295.5 303) rotate(90) scale(306)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7931A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9900",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1_488"
}, /*#__PURE__*/React.createElement("rect", {
  width: 592,
  height: 608,
  rx: 8,
  fill: "white"
})));

function SvgLightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 592,
    height: 608,
    viewBox: "0 0 592 608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_488)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_488)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_488",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -104,
    y: -96,
    width: 800,
    height: 800
  }, _ref2), _ref3)), _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBg);
export default __webpack_public_path__ + "static/media/lightBg.6489353e2958df5fa1ca9cb4a7cdca74.svg";
export { ForwardRef as ReactComponent };